/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *                _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 *
 */

/**
 * @module bulb-heading/bulbheading
 */

import { Plugin, HeadingButtonsUI, ParagraphButtonUI } from 'ckeditor5';

import BulbHeadingUi from './bulbheadingui';

/**
 * The general insert heading plugin.
 *
 * @extends module:core/plugin~Plugin
 */
export default class BulbHeading extends Plugin {

  /**
   * @inheritDoc
   */
  public static get requires() {
    return [BulbHeadingUi, HeadingButtonsUI, ParagraphButtonUI] as const;
  }

  /**
   * @inheritDoc
   */
  public static get pluginName() {
    return 'BulbHeading' as const;
  }
}
